<template>
    <el-dialog :visible.sync="dialogVisible" :title="data.id ? '更新投放信息':'添加投放信息'"
               custom-class="news-form-dialog"
               class="global-dialog"
               width="700px"
               :close-on-click-modal="false">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="70px">
            <el-form-item label="生效时间" prop="time">
                <el-date-picker class="c-time-section" style="width: 100%;" value-format="yyyy-MM-dd HH:mm" @change="onTimeChange"
                        v-model="ruleForm.time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="选择项目" prop="projectIds" class="news-proj">
                <el-select v-model="ruleForm.projectIds" filterable clearable  multiple style="width:100%">
                    <el-option v-for="(item, index) in  projects" :label="item.name" :value="item.id" :key="index">{{item.name}}</el-option>
                </el-select>
                <el-button type="default" size="mini" @click="onSelectAllProj">{{isAll ? '清空' : '全选'}}</el-button>
            </el-form-item>
            <!--<el-form-item label="选择人员" prop="userIds">-->
                <!--<el-select  v-model="ruleForm.userIds" multiple clearable filterable	 style="width:100%">-->
                    <!--<el-option v-for=" (item, key) in  projectUsers" :label="item.name" :value="item.id" :key="key">{{item.name}}</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item label="投放文案" prop="name">
                <el-input  type="textarea" :rows="4" v-model="ruleForm.name"  placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="投放图片" prop="content">
                <el-upload multiple
                           :action="uploadUrl"
                           :disabled="progressLoading"
                           :show-file-list="false"
                           :auto-upload="true" accept=".png,.jpg" list-type="picture"
                           :on-success="onUploadSuccess"
                           :on-error="onError"
                           :before-upload="onBeforeUpload">
                    <el-button ref="localUploadBtnRef" class="c-btn-color size-15"
                               :class="{'c-disabled': progressLoading}"
                               size="small" :loading="progressLoading">上传图片
                    </el-button>
                </el-upload>
                <div class="news-imgs">
                    <div class="news-img" v-for="(url, index) in fileList" :key="index">
                        <div class="del-bg">
                            <i class="el-icon-circle-close del-icon" @click="onDelImg(index)"></i>
                        </div>
                        <img :src="url" />
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="default" @click="onCancel">取消</el-button>
            <el-button type="primary" @click="onSave" :loading="loading" v-if="edit">保存</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import newsService from '../../../request/service/news-service'
    import userService from '../../../request/service/user-service'
    import {MATERIAL_UPLOAD} from '../../../request/api/fileupload-api';
    import util from '@/util.js';
    export default {
        props: {
            value: Boolean,
            edit: Boolean,
            data: {
                type: Object, default(){
                    return {}
                }
            }
        },
        data() {
            return {
                uploadUrl: MATERIAL_UPLOAD,
                loading: false,
                progressLoading: false,
                projectUsers: {},
                isAll: false,
                ruleForm: {
                    launchTime: null,
                    withdrawTime: null,
                    time: '',
                    projectIds: [],
                    userIds: [],
                    name:'',
                    content: '',
                },
                rules: {
                    projectIds: [
                        { required: true, message: '项目名称不能为空', trigger: 'change' },
                    ],
                    name: [
                        { required: true, message: '投放文案不能为空', trigger: 'change' },
                    ],
                    content: [
                        { required: false, message: '内容不能为空', trigger: 'change' },
                    ],
                }
            }
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            },
            projects () {
                return this.$store.state.app.loginUser.projectItems;
            },
            fileList(){
                let content = this.ruleForm.content;
                if(content){
                    return content.split(',');
                }else {
                    return null;
                }
            }
        },
        watch:{
            dialogVisible: {
                handler(v) {
                    if (v) {
                        this.init()
                    }else{
                        this.reset();
                    }
                },
                immediate: true
            },
        },
        methods: {
            init() {
                if(this.data && this.data.id){
                    this.setDefaultValue();
                }
            },
            async setDefaultValue(){
                // let ids = this.data.userIds;
                // if (ids && ids.length > 0) {
                //     ids = new Set(ids); // 去重
                //     ids = [...ids];
                //     this.data.userIds = ids;
                //     let data = await userService.getByIds(ids).catch(() => {
                //     });
                //     this.formatterUsers(data);
                // }
                for (let key in this.ruleForm) {
                    this.ruleForm[key] = this.data[key];
                }
                let launchTime = this.ruleForm.launchTime;
                let withdrawTime = this.ruleForm.withdrawTime;
                if(launchTime && withdrawTime){
                    this.ruleForm.time = [new Date(launchTime), new Date(withdrawTime)];
                }
            },
            onProjectChange(){
                // if(idArray && idArray.length > 0){
                //     this.getProjectUsers(idArray[idArray.length - 1]);
                // }else{
                //     this.cleanUsers();
                // }
            },
            cleanUsers(){
                this.ruleForm.userIds = [];
                this.projectUsers = {};
            },
            getProjectUsers(projectId){
                if(projectId){
                    userService.getProjectUsers(projectId).then((data) => {
                        if(data && data.length > 0){
                            this.formatterUsers(data)
                        }
                    });
                }
            },
            formatterUsers(dataList){
                let obj = {}, projectUsers = this.projectUsers;
                dataList.forEach((item) => {
                    obj[item.id] = item;
                    if(!Object.hasOwnProperty(projectUsers)){
                        this.$set(projectUsers, item.id, item);
                    }
                });
                return obj;
            },
            reset(){
                // this.cleanUsers();
                this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
            },
            onCancel() {
                this.$emit('input', false);
            },
            alertValidationMsg(){
                let projectIds = this.ruleForm.projectIds;
                if(projectIds && projectIds.length === 0){
                    this.$message.error('项目不能为空');
                    return;
                }
                let text = this.ruleForm.content || '';
                if(text.trim().length === 0){
                    this.$message.error('投放图片不能为空');
                    return;
                }
                let name = this.ruleForm.name || '';
                if(name.trim().length === 0){
                    this.$message.error('投放文案不能为空');
                    return;
                }
            },
            onSave() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if(this.data && this.data.id){
                            this.update();
                        }else{
                            this.save();
                        }
                    } else {
                        this.alertValidationMsg();
                        return false;
                    }
                });
            },
            update(){
                this.loading = true;
                let formData = Object.assign({},this.data, this.ruleForm);
                newsService.updateNews(formData).then(() => {
                    this.$message.success('更新成功');
                    this.$emit('submit');
                    this.$emit('input', false);
                }).finally(() => {
                    this.loading = false;
                });
            },
            save(){
                this.loading = true;
                newsService.addNews(this.ruleForm).then(() => {
                    this.$message.success('添加成功');
                    this.$emit('submit');
                    this.$emit('input', false);
                }).finally(() => {
                    this.loading = false;
                });
            },
            onError(){
                this.progressLoading = false;
            },
            onUploadSuccess(response) {
                if (response.code === 200) {
                    let {url} = response.result;
                    if(this.ruleForm.content){
                        let arr = this.ruleForm.content.split(',');
                        arr.push(url);
                        this.ruleForm.content = arr.join(',');
                    }else{
                        this.ruleForm.content = url;
                    }
                }
                this.progressLoading = false;
            },
            onBeforeUpload(file) {
                if(util.validateOnBeforeUpload(file)){
                    this.progressLoading = true;
                    return true;
                } else {
                    this.$message.error('请选择png/jpg图片');
                    return false;
                }
            },
            onDelImg(index){
                let arr = this.fileList;
                arr.splice(index, 1);
                this.ruleForm.content = arr.join(',');
            },
            onSelectAllProj(){
                this.isAll = !this.isAll;
                if(this.isAll){
                    this.ruleForm.projectIds = this.projects.map((item) => {
                        return item.id;
                    });
                }else{
                    this.ruleForm.projectIds = [];
                }
            },
            onTimeChange(data){
                this.ruleForm.launchTime = data[0];
                this.ruleForm.withdrawTime = data[1];
            }
        }
    }
</script>
<style lang="scss">
    @import "./news-form-dialog.scss";
</style>
